// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
  }
  
  .modal-content {
    background: white;
    padding: 20px 20px 25px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
   background-color: black;
  }
  
  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #fff;
  }
  .btnPopUp{
    align-items: center;
    display: flex;
    gap: 19px;
  
  }
  .modal-content h3 {
    color: wheat;
}

.getStartBtn{
  transition: all .3s ease;
  position: relative;
  z-index: 1;
  padding: 9px 18px;
  cursor: pointer;
  font-weight: 300;
  font-size: 14px;
  border-radius: 6px;
  outline: none !important;
  line-height: normal;
  color: #fff;
  display: inline-block;
}
.getStartBtn::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  background-image: linear-gradient(90deg, #010103 1%, #121F4D 21%, #FB4243 50%, #121F4D 80%);
  background-size: 250%;
  background-position: left;
  transition: all .5s ease;
}

.getStartBtn::after {
  content: "";
  position: absolute;
  inset: -1px;
  z-index: -2;
  border-radius: inherit;
  background-image: linear-gradient(90deg, #FE8F00 10.35%, #FE0100 92.29%);
}`, "",{"version":3,"sources":["webpack://./src/Components/Popup/Popup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;GACZ,uBAAuB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,SAAS;;EAEX;EACA;IACE,YAAY;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,2FAA2F;EAC3F,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,wEAAwE;AAC1E","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 99;\n  }\n  \n  .modal-content {\n    background: white;\n    padding: 20px 20px 25px;\n    border-radius: 8px;\n    max-width: 500px;\n    width: 100%;\n   background-color: black;\n  }\n  \n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #fff;\n  }\n  .btnPopUp{\n    align-items: center;\n    display: flex;\n    gap: 19px;\n  \n  }\n  .modal-content h3 {\n    color: wheat;\n}\n\n.getStartBtn{\n  transition: all .3s ease;\n  position: relative;\n  z-index: 1;\n  padding: 9px 18px;\n  cursor: pointer;\n  font-weight: 300;\n  font-size: 14px;\n  border-radius: 6px;\n  outline: none !important;\n  line-height: normal;\n  color: #fff;\n  display: inline-block;\n}\n.getStartBtn::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  border-radius: inherit;\n  background-image: linear-gradient(90deg, #010103 1%, #121F4D 21%, #FB4243 50%, #121F4D 80%);\n  background-size: 250%;\n  background-position: left;\n  transition: all .5s ease;\n}\n\n.getStartBtn::after {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  z-index: -2;\n  border-radius: inherit;\n  background-image: linear-gradient(90deg, #FE8F00 10.35%, #FE0100 92.29%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
